export { SimilarHotelMediaSnippet } from './SimilarHotelMediaSnippet'
